export const createForgeProps = <T = any>(
  defaultProps: Partial<T>,
  overrideProps?: Partial<T>,
): Partial<T> => {
  return {
    ...defaultProps,
    ...(overrideProps || {}),
  };
};

export default createForgeProps;
